import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { appConfig } from '../constant/app.constant';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root'
})
export class TechSupportService {


  private _url = `${appConfig.BASE_URL}techsupport`;

  constructor(private httpClient: HttpClient, private spinnerService: SpinnerService) { }

  bookCustomerService(itemDetails)
  {
    const request={
      customerServiceURI:"url",
      customerServiceToken:"token",
      data:itemDetails
      
    }
    

    return this.httpClient.post(`${this._url}/BookCustomerService`, request).pipe(
    );
  }
}
